/**
 * Formats a latency value (in milliseconds) to a human-readable string
 * showing days, hours, minutes, seconds, and milliseconds.
 * Only non-zero units are displayed.
 *
 * @param milliseconds - The latency value in milliseconds
 * @returns A formatted string like "2d 4h 22m 3s 11ms", or empty string if value is null/undefined
 */
export function formatLatency(milliseconds: number | null | undefined): string {
  if (milliseconds == null) {
    return "";
  }

  // Handle negative values by taking absolute value
  const absMs = Math.abs(milliseconds);

  // Calculate each time unit
  const days = Math.floor(absMs / (24 * 60 * 60 * 1000));
  const hours = Math.floor((absMs % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const minutes = Math.floor((absMs % (60 * 60 * 1000)) / (60 * 1000));
  const seconds = Math.floor((absMs % (60 * 1000)) / 1000);
  const ms = absMs % 1000;

  // Build the output string with only non-zero components
  const parts: string[] = [];

  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (seconds > 0) parts.push(`${seconds}s`);
  if (ms > 0) parts.push(`${ms}ms`);

  // Return joined parts or "0ms" if all components are zero
  return parts.length > 0 ? parts.join(" ") : "0ms";
}
